import axios from 'axios';

export const getErrorMessage = (error: unknown): string => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data;

    if (typeof data === 'string') {
      return data;
    }

    if (typeof data?.message === 'string') {
      return data.message;
    }

    if (typeof data?.Message === 'string') {
      return data.Message;
    }

    if (typeof data?.title === 'string') {
      return data.title;
    }

    if (Array.isArray(data?.errors) && data.errors.length > 0) {
      return data.errors.join(', ');
    }

    if (Array.isArray(data?.Errors) && data.Errors.length > 0) {
      return data.Errors.join(', ');
    }

    return error.message || 'Unknown error';
  }

  if (error instanceof Error) {
    return error.message;
  }

  return 'Unknown error';
};
